var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"checkbox"},[_c('input',{staticClass:"checkbox_input",attrs:{"id":_vm.id,"type":"checkbox","disabled":_vm.disabled},domProps:{"checked":_vm.state},on:{"change":function($event){return _vm.check($event.target.checked)}}}),_c('label',{class:[
      'checkbox_label',
      `-${_vm.size}`,
      `-${_vm.appearance}`,
      { '-checked': _vm.state },
      { '-disabled': _vm.disabled },
    ],attrs:{"for":_vm.id}},[(_vm.$slots.label)?[_vm._t("label")]:_c('span',[(_vm.strikeThrough)?_c('del',[_vm._v(_vm._s(_vm.label))]):[_vm._v(_vm._s(_vm.label))]],2)],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }